import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  onSearch() {
    if (this.inputTarget.value === "") {
      const url = new URL(window.location.href)
      url.searchParams.delete("q")
      Turbo.visit(url.toString())
    } else {
      this.element.requestSubmit()
    }
  }
}
